import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

import { ModalData, ModalRef } from '@purespectrum1/ui/modal';
import { ToasterService } from '@purespectrum1/ui/toaster-service';

import { Subscription } from 'rxjs';

// Services
import { AuthService } from '../../../shared/services/auth/auth.service';
import { BuyerService } from '../../../shared/services/buyer/buyer.service';

// Interfaces
import { ReportPreferences } from '../../../shared/interfaces/buyer.interface';
import { AuthState } from '../../../shared/interfaces/auth.interface';

export type Data = {
  authState?: AuthState;
};
@Component({
  selector: 'ps-ui-customize-report-modal',
  templateUrl: './customize-report-modal.component.html',
  styleUrls: ['./customize-report-modal.component.css'],
})
export class CustomizeReportModalComponent implements OnInit, OnDestroy {
  private _subscription: Subscription = new Subscription();
  public searchText: string = '';
  public selectedColumnsCount: number = 0;
  public reportPreferences: ReportPreferences[] = [];

  constructor(
    private _modalRef: ModalRef<CustomizeReportModalComponent, string>,
    private _auth: AuthService,
    private _toastr: ToasterService,
    private _buyerService: BuyerService,
    @Inject(ModalData) private _modalData?: Data
  ) {
    // For external integration of the component, one case pass auth state
    if (this._modalData?.authState) {
      this._auth.setState(this._modalData.authState);
    }
  }

  ngOnInit(): void {
    const userId = this._auth.user?.id || 0;
    this._buyerService.getReportPreference(userId).subscribe(
      (response: ReportPreferences[]) => {
        this.reportPreferences = response;
        this._countSelectedColumns();
      },
      (error) => {
        this._toastr.error(error.error.msg);
      }
    );
  }

  selectPreferance(reportPreference: ReportPreferences, value: boolean) {
    reportPreference.is_selected = !value;
    this._countSelectedColumns();
  }

  private _countSelectedColumns() {
    this.selectedColumnsCount = this.reportPreferences.reduce(
      (counter, { is_selected }) => {
        if (is_selected === true) {
          counter += 1;
        }
        return counter;
      },
      0
    );
  }

  close(msg?: string) {
    if (msg === 'save') {
      const userId = this._auth.user?.id || 0;
      const payload: number[] = this.reportPreferences
        .filter((pref) => pref.is_selected)
        .map((reportPreference) => {
          return reportPreference._id;
        });

      this._buyerService
        .saveReportPreference(userId, { preferences: payload })
        .subscribe(
          () => {
            this._modalRef.close();
            this._toastr.success('Preferences Saved sucessfully!!');
          },
          (error) => {
            this._toastr.error(error.error.msg);
          }
        );
    } else {
      this._modalRef.close();
    }
  }

  dropColumns(event: CdkDragDrop<ReportPreferences[]>) {
    moveItemInArray(
      this.reportPreferences,
      event.previousIndex,
      event.currentIndex
    );
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }
}
